import gql from "graphql-tag";

export default gql`
  query superAdminGetCompanyUserUsernameAlias($userId: ID!) {
    superAdminGetCompanyUserUsernameAlias(userId: $userId)
  }
`;
